import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import api from "../../lib/api";
import { AdminHeader, Btn, DataTable, Card, Input, Select } from "../../components/admin/Fields";

const empty = () => ({ email: "", name: "", password: "", role: "admin" });

const AdminUsersPage = () => {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(empty());
  const [busy, setBusy] = useState(false);
  const [creating, setCreating] = useState(false);
  const load = () => api.get("/admin/users").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/admin/users", form);
      setForm(empty()); setCreating(false); load();
      toast.success("Kullanıcı oluşturuldu");
    } catch (err) { toast.error(err?.response?.data?.detail || err.message); } finally { setBusy(false); }
  };
  const remove = async (r) => {
    if (!window.confirm(`"${r.email}" silinsin mi?`)) return;
    try { await api.delete(`/admin/users/${r.id}`); load(); }
    catch (err) { toast.error(err?.response?.data?.detail || err.message); }
  };

  return (
    <div data-testid="admin-users-page">
      <AdminHeader eyebrow="Access" title="Kullanıcılar" action={<Btn onClick={() => setCreating(true)} testId="new-user"><Plus size={14} /> Yeni</Btn>} />
      {creating ? (
        <Card title="Yeni Kullanıcı">
          <form onSubmit={create} className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
            <Input label="Email" type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} testId="user-email" />
            <Input label="Ad" value={form.name} onChange={(v) => setForm({ ...form, name: v })} testId="user-name" />
            <Input label="Şifre" type="password" value={form.password} onChange={(v) => setForm({ ...form, password: v })} testId="user-password" />
            <Select label="Rol" value={form.role} onChange={(v) => setForm({ ...form, role: v })} options={[{ value: "admin", label: "Admin" }, { value: "editor", label: "Editor" }, { value: "viewer", label: "Viewer" }]} />
            <div className="md:col-span-4 flex gap-3">
              <Btn type="submit" disabled={busy} testId="user-save">Kaydet</Btn>
              <Btn variant="ghost" onClick={() => setCreating(false)}>İptal</Btn>
            </div>
          </form>
        </Card>
      ) : null}
      <div className="mt-6">
        <DataTable
          columns={[
            { key: "email", label: "Email" },
            { key: "name", label: "Ad" },
            { key: "role", label: "Rol" },
            { key: "actions", label: "", render: (r) => <div className="flex justify-end"><Btn variant="danger" onClick={() => remove(r)}><Trash2 size={12} /></Btn></div> },
          ]}
          rows={rows}
        />
      </div>
    </div>
  );
};

export default AdminUsersPage;
